import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from "recharts";
import * as moment from "moment";

import loader from "../../images/Spin-1s-107px.gif";
import BigMoney from "../common/bigMoney";

import {
  getSettlementDetailForGroup,
  getBarGraphDataForDashboard,
  clearBarGraphDataForDashboard,
  getAllSettlementListOfUserById,
  getBarGraphDataForDashboardWithSettlementIdForParentUserForGroup,
} from "../../Actions/actions";

class settlementDetailContainerByGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      barGraphData1: {},
      userId: localStorage.getItem("userId"),
      isLoader: false
    };
  }

  componentDidMount() {
    const userObject = JSON.parse(localStorage.getItem("userObject"))
    const { userId,groupId } = this.state;
    // const {
    //   getBarGraphDataForDashboard,
    //   getAllSettlementListOfUserById,
    //   getBarGraphDataForDashboardWithSettlementIdForParentUserForGroup,
    //   match: { params }
    // } = this.props;
    const { match:{ params } } = this.props;
    this.setState({
      isLoader: true
    });
    // getBarGraphDataForDashboard({ userId, settlementId: params && params.id });
    // getAllSettlementListOfUserById({ userId, id: params && params.id });
    this.props.getBarGraphDataForDashboardWithSettlementIdForParentUserForGroup({ partnerId:params.partnerId, settlementId: params && params.id,groupId:params.groupId });
    // this.props.getSettlementDetailForGroup({ userId, id: params && params.id,groupId:params.groupId });
    this.props.getSettlementDetailForGroup({ userId, id: params && params.id,partnerId:params && params.partnerId });
    // await this.props.getAffiliateUser(userid);
  }

  componentWillUnmount() {
    this.props.clearBarGraphDataForDashboard([]);
  }



  componentDidUpdate() {
    const { parentBarGraphData,receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroupReducer } = this.props.data;
    // console.log('receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroupReducer', receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroupReducer)
    const { barGraphData1 } = this.state;
    if (receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroupReducer !== undefined) {
      if (barGraphData1 !== receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroupReducer) {
        if (receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroupReducer.barGraphDtos !== undefined) {
          const dataBarGraph = [];

          receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroupReducer && receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroupReducer.barGraphDtos.map((barGraphDtos) => {
            dataBarGraph.push({
              name: barGraphDtos.monthLabel,
              Users: barGraphDtos.users,
              Enrollments: barGraphDtos.enrollments
            });
            return true
          })

          // for (
          //   let index = 0;
          //   index <= barGraphData.dataSetDtos[1].data.length;
          //   index++
          // ) {
          //   dataBarGraph.push({
          //     name: barGraphData.labels[index],
          //     Users: barGraphData.dataSetDtos[0].data[index],
          //     Enrollments: barGraphData.dataSetDtos[1].data[index]
          //   });
          // }
          this.setState({
            chartDataGraph: dataBarGraph,
            // settlementUserIdAffiliateData2:settlementUserIdAffiliateData1.userDto
          });
        }
        this.setState({
          barGraphData1: receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroupReducer,
          isLoader: false

        })
      }
    }
  }

  render() {
    const { chartDataGraph, isLoader, } = this.state;
    const {
      data: { settlementUserIdAffiliateData, parentBarGraphData,receiveGetSettlementDetailForGroup, receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroupReducer },
      match: { params }
    } = this.props;

    return (
      <div className="">
        {/* {console.log('barGraphData', parentBarGraphData)} */}
        {isLoader === true ? (
          <div className="loader">
            <img src={loader} alt="" />
          </div>
        ) : (
            ""
          )}

        <div className="p-settlement-detail">
          <div className="breadcrumbs">
            <span> Settlement</span>
            <span>></span>
            <span>
              <Link to={`/settlementAffiliate/${params && params.id}`}>
                {" "}
                {receiveGetSettlementDetailForGroup &&
                  receiveGetSettlementDetailForGroup.shortName}
              </Link>
            </span>
          </div>
          <div className="p-settlement-heading">
            <h3 className="p-h3">
              {receiveGetSettlementDetailForGroup &&
                receiveGetSettlementDetailForGroup.shortName}{" "}
            </h3>
            <h4 className="p-h4">
              Details
              {/* {console.log('params', params)} */}
              <Link
                to={`/settlementAffiliate/settlement-details/${params && params.id}/${params && params.groupId}/${params && params.partnerId}`}
                // to={`/SettlementAffiliate/${params && params.id}`}
                className="view-settlement-link p-font-medium"
              >
                View Full Details
              </Link>
            </h4>
            <div className="p-settlement-cost-item p-d-flex">
              <div className="p-cost-item">
                <label className="text-uppercase p-font-bold">Settlement</label>
                <h5 className="p-h4">
                  {receiveGetSettlementDetailForGroup && receiveGetSettlementDetailForGroup.tbdAmount !== "TBD" ? (<BigMoney
                    value={
                      receiveGetSettlementDetailForGroup &&
                      receiveGetSettlementDetailForGroup.totalMoneyAvailable
                    }
                  />) : " TBD"}

                </h5>
              </div>
              <div className="p-cost-item">
                <label className="text-uppercase p-font-bold">
                  Filing Deadline
                </label>
                <h5 className="">
                  {receiveGetSettlementDetailForGroup &&
                    receiveGetSettlementDetailForGroup.settlementImportantDateDto !==
                    undefined
                    ? moment(
                      receiveGetSettlementDetailForGroup.settlementImportantDateDto
                        .claimPeriodEnd !== undefined
                        ? receiveGetSettlementDetailForGroup
                          .settlementImportantDateDto.claimPeriodEnd
                        : ""
                    ).format("MM-DD-YYYY") !== "Invalid date"
                      ? moment(
                        receiveGetSettlementDetailForGroup
                          .settlementImportantDateDto.claimPeriodEnd !==
                          undefined
                          ? receiveGetSettlementDetailForGroup
                            .settlementImportantDateDto.claimPeriodEnd
                          : ""
                      ).format("MM/DD/YYYY")
                      : "n/a"
                    : ""}{" "}
                </h5>
              </div>
            </div>
          </div>
          <h4 className="p-h4">Performance</h4>
          <div className="p-settlement-performance p-d-flex">
            <div className="p-settlement-performance-left">
              <div className="p-card p-card-blue">
                <h2>
                  {receiveGetSettlementDetailForGroup &&
                    receiveGetSettlementDetailForGroup.enrollmentCount
                    ? receiveGetSettlementDetailForGroup.enrollmentCount
                    : 0}
                </h2>
                <p>Total Enrollments</p>
              </div>
              <div className="p-card">
                <h2>${receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroupReducer.totalRecovery ? receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroupReducer.totalRecovery.toFixed(2) : 0}</h2>
                <p className="text-ltgrey p-font-bold text-uppercase">
                  Total Recovery
                </p>
              </div>
              <Link className="view-settlement-link p-font-medium mt-none"
                to={`/settlementAffiliate/enrollment-list/${params && params.id}/${params && params.groupId}/${params && params.partnerId}`}
              >
                View List of Enrollments
              </Link>
            </div>
            <div className={receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroupReducer && receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroupReducer.length === 0 ? "p-overview-Settlements-right no-record-graph" : "p-settlement-performance-right"}>
              {receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroupReducer && receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroupReducer.length === 0 ? (
                <div>
                  No Data
              </div>) : (
                  <div>
                    <div className="graph-heading">Users + Enrollments</div>
                    <BarChart width={700} height={270} data={chartDataGraph}>
                      <CartesianGrid vertical={false} />

                      <XAxis dataKey="name" />
                      <YAxis />
                      <Tooltip />
                      <Legend iconType="circle" />
                      <Bar maxBarSize={8} dataKey="Users" fill="#19d490" radius={20} />
                      <Bar maxBarSize={8} dataKey="Enrollments" fill="#e220b2" radius={20} />
                    </BarChart>
                  </div>
                )}
            </div>

            {/* <div className="p-settlement-performance-right">
              <div className="graph-heading">Users + Enrollments</div>
              <BarChart width={700} height={270} data={chartDataGraph}>
                <CartesianGrid vertical={false} />

                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend iconType="circle" />
                <Bar
                  maxBarSize={8}
                  dataKey="Users"
                  fill="#19d490"
                  radius={20}
                />
                <Bar
                  maxBarSize={8}
                  dataKey="Enrollments"
                  fill="#e220b2"
                  radius={20}
                />
              </BarChart>
            </div> */}
          </div>
          {/* <div className="p-settlement-resources">
            <h4 className="p-h4">Resources</h4>
            <h5>Registration Link</h5>
            <Link
              className="login-link p-font-medium  p-d-flex"
              to={`/settlementAffiliate/${params && params.id}`}
            >
              Longlinknamehere
            </Link>
            <Link className="copy-btn" to={`/settlementAffiliate/${params && params.id}`}>
              Copy Link
            </Link>
            <div className="settlement-sample-email">
              <h5>Sample Customer Email</h5>
              <p>Introduces customers to the Collectively filing option</p>
              <Link className="view-settlement-link" to={`/settlementAffiliate/${params && params.id}`}>
                View Sample Customer Email
              </Link>
            </div>
            <div className="settlement-sample-email">
              <h5>Sample Landing Page</h5>
              <p>Where customers enroll with Collectively</p>
              <Link className="view-settlement-link" to={`/settlementAffiliate/${params && params.id}`}>
                Sample Landing Page
              </Link>
            </div>
          </div> */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({ data: state.data });

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getSettlementDetailForGroup,
      getBarGraphDataForDashboard,
      clearBarGraphDataForDashboard,
      getAllSettlementListOfUserById,
      getBarGraphDataForDashboardWithSettlementIdForParentUserForGroup
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(settlementDetailContainerByGroup);
